import { Inject, Injectable } from "@angular/core";
import { ModalFactory } from "@nms-ng2/app/shared/services/modal/modal.factory";
import { AddLinkModalComponent } from "../links/modal-wizard/add-link-modal.component";
import { Device } from "../../device/device-backup/device-backup.models";
import {
    ANGULARJS_TRANSLATE, AUTHENTICATION_SERVICE, NMS_FEATURES
} from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { NmsDialogService } from "@nms-angular-toolkit/nms-dialog";
import { EndLink, Link, Transmission } from "../links/links.model";
import { ConfirmAddLinkModalComponent } from "./confirm-add-link-modal/confirm-add-link-modal.component";
import { DevicePollingVerifierService } from "@nms-ng2/app/shared/services/polling/device-polling-verifier.service";
import { LinkService } from "../links/services/link.service";

/**
 * Utilitário para ações nos atalhos de links.
 */
@Injectable({
    providedIn: "root"
})
export class LinksShortcutActionService {

    constructor(@Inject(ModalFactory) private readonly modalFactory: ModalFactory,
        @Inject(ANGULARJS_TRANSLATE) private readonly translate,
        @Inject(AUTHENTICATION_SERVICE) private readonly authenticationService: any,
        @Inject(NMS_FEATURES) private readonly nmsFeatures: any,
        private readonly nmsDialogService: NmsDialogService,
        private readonly linkService: LinkService,
        private readonly devicePollingVerifier: DevicePollingVerifierService) { }

    async openAddLinkModal(devices: Device[]) {
        if (this.userHasPermission(this.nmsFeatures.linkConfiguration.feature) && this.isValidSelectedDevicesSize(devices)) {
            if (devices.length === 2) {
                const successCallback = async () => {
                    const callback = async (data) => {
                        const linkInfo: Link = await this.fillLinkData(data);
                        this.modalFactory.openAsyncModal(AddLinkModalComponent, { linkInfo: linkInfo });
                    }
                    this.modalFactory.openAsyncModal(ConfirmAddLinkModalComponent, { devices, successCallback: callback});
                };
                const devicesResourceIds = devices.map(device => device.id);
                this.devicePollingVerifier
                    .checkFirstPollingStatusForMultipleDevices(devicesResourceIds, successCallback);
            } else {
                const successCallback = async () => {
                    const linkInfo: Link = await this.fillLinkData(devices);
                    this.modalFactory.openAsyncModal(AddLinkModalComponent, { linkInfo: linkInfo });
                };
                this.devicePollingVerifier.checkFirstPollingStatus(devices[0].id, successCallback);
            }
        }
    }

    public userHasPermission(permission: string): boolean {
        const hasPermission = this.authenticationService.hasPermission(permission);

        if (!hasPermission) {
            this.nmsDialogService.openDialog({
                description: this.translate.instant("links.tableAction.noUserPermission"),
                acceptLabel: "OK"
            });
            return false;
        }

        return true;
    }

    private isValidSelectedDevicesSize(devices): boolean {
        if (devices.length == 0) {
            const message = this.translate.instant("links.managedDevices.tableAction.noSelectedDevices");
            this.nmsDialogService.openDialog({ description: message });
            return false;
        }

        if (devices.length > 2) {
            const message = this.translate.instant("links.managedDevices.tableAction.invalidDevicesSize");
            this.nmsDialogService.openDialog({ description: message });
            return false;
        }

        return true;
    }


    private async fillLinkData(devices: Device[]): Promise<Link> {
        const linkInfo: Link = {} as Link;
        linkInfo.generateName = true;
        linkInfo.aEnd = await this.fillEndData(devices[0].id);

        if (devices[1]) {
            linkInfo.zEnd = await this.fillEndData(devices[1].id);
        }

        return linkInfo;
    }

    private async fillEndData(deviceId: number): Promise<EndLink> {
        const endData = await this.linkService.getSlotPorts(deviceId).toPromise();
        return {
            deviceResourceId: deviceId,
            chassisNo: endData[0].chassisNo,
            slotNo: endData[0].slotNo,
            portNo: endData[0].ports[0].portNo,
            portModel: endData[0].ports[0].portModelId,
            transmission: Transmission.NONE,
            muxDemuxResourceId: null,
            muxDemux: false
        }
    }
}
